export default "__VITE_ASSET__3e7152c3__"